import React from 'react';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
// Constants
import { CompanyName, KeywordsPages } from '../../utils/Constants';
// Data
import {
  contactPageAdditionalMeta,
  contactPageStructuredData,
} from '../../utils/data/MetaData';
import ContactPageMainContainer from '../../components/contact/ContactPageMainContainer';
// Images
import MainImage from '../../assets/images/main/misress-diva-pro-dominatrix-and-femdom-angel-album-wings.webp';

function ContactPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Contact'
        desc={`Get in touch with ${CompanyName} for private sessions, bookings, and exclusive inquiries. Available worldwide.`}
        keywords={`${CompanyName}, contact, bookings, dominatrix, private sessions, tribute requests, BDSM, professional domme, online domination, ${KeywordsPages}`}
        additionalMeta={contactPageAdditionalMeta}
        structuredData={contactPageStructuredData}
      />

      {/* Page */}
      <div className='grid overflow-hidden text-colour1 dark:text-colour1 bg-colour2 dark:bg-colour2 font-poppins no__highlights'>
        <div className='grid'>
          {/* Navigation */}
          <Navbar />

          <header className='grid w-full '>
            <div className='grid gap-4 lg:gap-6 py-10'>
              {/* Main Header */}
              <section className='grid justify-center text-center leading-4'>
                <article className='grid gap-y-4 h-fit'>
                  <div>
                    <h1 className='text-3xl md:text-3xl lg:text-4xl font-kugile'>
                      BOOK A UNIQUE SESSION!
                    </h1>
                  </div>
                  <div>
                    <img src={MainImage} alt='Main Mistress' />
                  </div>
                </article>
              </section>
            </div>
          </header>

          {/* Main page content */}
          <ContactPageMainContainer />
        </div>
      </div>
    </>
  );
}

export default ContactPage;
